import { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";
import { Loader2, Plus, X } from "lucide-react";

export function ActivityTypesEditor() {
    const [types, setTypes] = useState(null);
    const [draft, setDraft] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        api.get("/presenze/activity-types")
            .then((r) => setTypes(r.data.types))
            .catch(() => { toast.error("Errore nel caricamento delle tipologie"); setTypes([]); });
    }, []);

    const persist = async (next) => {
        setSaving(true);
        try {
            const { data } = await api.put("/presenze/activity-types", { types: next });
            setTypes(data.types);
        } catch (e) {
            const d = e.response?.data?.detail;
            toast.error(typeof d === "string" ? d : "Errore nel salvataggio");
        } finally { setSaving(false); }
    };

    const add = () => {
        const name = draft.trim();
        if (!name) return;
        if (types.some((t) => t.toLowerCase() === name.toLowerCase())) { toast.error("Tipologia già presente"); return; }
        setDraft("");
        persist([...types, name]);
    };

    if (!types) return <div className="flex justify-center py-4"><Loader2 className="h-4 w-4 animate-spin text-slate-300" /></div>;

    return (
        <div data-testid="activity-types-editor">
            <div className="flex flex-wrap gap-1.5">
                {types.map((t) => (
                    <span key={t} className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-medium text-slate-700" data-testid={`activity-type-chip-${t}`}>
                        {t}
                        <button type="button" onClick={() => persist(types.filter((x) => x !== t))} disabled={saving || types.length === 1}
                            className="text-slate-400 hover:text-red-500 disabled:opacity-40" title="Rimuovi" data-testid={`activity-type-remove-${t}`}>
                            <X className="h-3 w-3" />
                        </button>
                    </span>
                ))}
            </div>
            <div className="mt-2 flex gap-2">
                <Input value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())}
                    placeholder="Nuova tipologia (es. Pulizia palestre)" className="h-9" data-testid="activity-type-input" />
                <Button type="button" variant="outline" onClick={add} disabled={saving || !draft.trim()} className="h-9 gap-1.5" data-testid="activity-type-add-btn">
                    {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Plus className="h-3.5 w-3.5" />} Aggiungi
                </Button>
            </div>
            <p className="mt-1.5 text-[11px] text-slate-500">Le tipologie sono proposte nell'assegnazione rapida; una tipologia digitata a mano viene aggiunta automaticamente all'elenco.</p>
        </div>
    );
}
